import { SchemaObjectDescription } from 'yup';

export const fieldLabel = (
  schemaDescription: SchemaObjectDescription['fields'],
  fieldName: string
) => {
  const field = schemaDescription[fieldName];
  return 'label' in field ? field.label : fieldName;
};
